const $ = require('jquery');

module.exports = function() {
    // FAQ slideout
    $('.faqwrapper .faq .answer').hide();
    $('.faqwrapper .faq .togglefaq').click(function(e){
        $('.faqwrapper .faq .answer').stop().slideUp(300);
        $('.faqwrapper .faq').addClass('hideanswer');
        $(this).closest('.faq').toggleClass('hideanswer');
        $(this).closest('.faq').find('.answer').stop().slideDown(300);
        e.preventDefault();
    });
}